import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { url_rest, types } from 'configuration'
import { getRequest, postRequest } from 'services/ApiService.js'


import MunicipalityLanding from 'pages/MunicipalityLanding.js'
import MunicipalityType from 'pages/MunicipalityType.js'
import ResourceFileContent from 'components/ResourceFileContent'
import ResourceFile from 'pages/ResourceFile.js'

class Municipality extends Component {
  render() {
    return (
      //<Layout contentType="municipality" queryTerm={this.props.match.params.slug} >
      <Router basename="/webapp">
        <Switch>
          <Route path="/:lang/destinos/:slug" exact={true} render={(props) => <MunicipalityLanding {...props} />} />
          <Route path="/:lang/destinos/:slug/:type" exact={true} render={(props) => <MunicipalityType queryType={props.match.params.type} {...props} />} />
          <Route path="/:lang/destinos/:context/:type/:slug" render={(props) => <ResourceFile contentType="destinos" {...props} />} />
        </Switch>
      </Router>
      //</Layout>
    );
  }
}

Municipality.propTypes = {
  classes: PropTypes.object.isRequired
};

export default translate()(Municipality);



// WEBPACK FOOTER //
// ./src/pages/Municipality.js